import * as React from 'react';
import {CenterHorizontalWrapper, CenterVerticalColumnWrapper} from '../../styled-components/CenterWrapper';
import {SCREENS, WP_CONTENT_PREFIX} from '../../constants';
import {Background} from '../../styled-components/Background';
import {PlotAreaWrapper, PlotArea, PlotAreaMargin} from '../../styled-components/PlotAreaComps';
import styled from 'styled-components';
import {analyticsEvent, sendGAEventToExtension} from '../../utils/analytics';
import {StatusBar} from '../StatusBar';
import {GroundInfo, InfoTitle, GestureGif} from "../GroundInfo";
import {Title} from "../../styled-components/Title";
import {Cloud} from "../../styled-components/Cloud";
import {MenuOverlay} from "../MenuOverlay";
import {HelpOverlay} from "../HelpOverlay";
import I18n from "../../utils/i18n";
import ReactHtmlParser from 'react-html-parser';
import BouncePrevention from '../../utils/BouncePrevention';
import {BounceOverlay} from "../BounceOverlay";

const MouseChaseLogo = styled.img`
    width: 30vw;
    height: 10vh;
    margin-top: 2vh;
`;

const Mouse = styled.img`
    height: 13vh;
    margin-top: ${props => props.marginTop};
    padding: ${props => props.marginTop === '25vh' ? '0 15vw' : 'unset'};
`;

const CTALink = styled.a`
  text-decoration: none;
`;

const CTAWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3vh;
    &:hover div {
    background-color: #0e71c3;
    }
`;

const CTASide = styled.div`
    width: 0.4vw;
    height: 6vh;
    box-shadow: inset 0 4px 0 0 rgba(255, 255, 255, 0.25);
    background-color: #0c80df;
`;

const CTAMiddle = styled.div`
    width: 19vw;
    height: 8vh;
    box-shadow: inset 0 4px 0 0 rgba(255, 255, 255, 0.25);
    background-color: #0c80df;
    font-family: 'Pixel Coleco';
    font-size: 2.7vh;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
`;

const CTAImage = styled.img`
    height: 4vh;
    width: 4vh;   
`;

export class FirstScreen extends React.Component {

    constructor() {
        super();
        this.OVERLAY_TYPES = {
            menu: 'menu',
            help: 'help',
            bounce: 'bounce'
        };
        this.state = {
            showMenuOverlay: true,
            showHelpOverlay: false,
            showBounceOverlay: false,
            currentOverlay: this.OVERLAY_TYPES.menu
        };
        this.ctaClicked = this.ctaClicked.bind(this);
        this.closeMenuOverlay = this.closeMenuOverlay.bind(this);
        this.closeHelpOverlay = this.closeHelpOverlay.bind(this);
        this.closeBounceOverlay = this.closeBounceOverlay.bind(this);
        this.renderOverlays = this.renderOverlays.bind(this);
    }


    closeMenuOverlay() {
        this.setState({
            showMenuOverlay: false,
            currentOverlay: null
        });
        BouncePrevention.startObserving(() => {
            this.setState({
                showHelpOverlay: true
            });
        });
        BouncePrevention.startBouncePrevention(() => {
            this.setState({
                showBounceOverlay: true
            })
        })
    }

    ctaClicked() {
        analyticsEvent('Onboarding',
            'Screen 0',
            'CTA Clicked'
        );
    }

    closeHelpOverlay() {
        this.setState({
            showHelpOverlay: false
        });
    }

    closeBounceOverlay() {
        this.setState({
            showBounceOverlay: false
        });
    }

    renderOverlays() {
        const {extensionInstalled, toggleMusicPlaying, musicPlaying} = this.props;
        const {currentOverlay} = this.state;
        if(!extensionInstalled) {
            return null;
        }
        if(currentOverlay === this.OVERLAY_TYPES.menu) {
            return <MenuOverlay closeMenuOverlay={this.closeMenuOverlay} toggleMusicPlaying={toggleMusicPlaying} musicPlaying={musicPlaying}/>;
        } else if (currentOverlay === this.OVERLAY_TYPES.help) {
            return <HelpOverlay closeHelpOverlay={this.closeHelpOverlay} screen={SCREENS.first} />
        } else if (currentOverlay === this.OVERLAY_TYPES.bounce) {
            return <BounceOverlay screen={SCREENS.first} closeBounceOverlay={this.closeBounceOverlay} />
        } else {
            return null;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {showHelpOverlay, showBounceOverlay} = this.state;

        // hide help overlay
        if (showHelpOverlay && !nextState.showHelpOverlay) {
            this.setState({
                showBounceOverlay: false,
                currentOverlay: null
            });
        // show help overlay
        } else if (!showHelpOverlay && nextState.showHelpOverlay) {
            this.setState({
                currentOverlay: showBounceOverlay ? this.OVERLAY_TYPES.bounce : this.OVERLAY_TYPES.help
            });
        }
        // hide bounce overlay
        if (showBounceOverlay && !nextState.showBounceOverlay) {
            this.setState({
                showHelpOverlay: false,
                currentOverlay: null
            });
        // show bounce overlay
        } else if (!showBounceOverlay && nextState.showBounceOverlay) {
            this.setState({
                currentOverlay: showHelpOverlay ? this.OVERLAY_TYPES.help : this.OVERLAY_TYPES.bounce
            });
        }
        return true;
    }


    componentDidMount() {
        const {extensionInstalled} = this.props;
        if(localStorage.getItem('sourceShare') === null) {
            localStorage.setItem('sourceShare', JSON.stringify(!extensionInstalled));
        }
        const currentScreen = extensionInstalled ? '1' : '0';
        analyticsEvent('Onboarding',
            `Screen ${currentScreen}`,
            'Shown'
        );
        history.pushState({screen: currentScreen}, "", `?screen=${currentScreen}`);

        if(extensionInstalled) {
            sendGAEventToExtension('Onboarding', 'Screen 1', 'Shown');
        }
    }

    render() {
        const {extensionInstalled, toggleMusicPlaying, musicPlaying} = this.props;
        const extensionPage = 'https://chrome.google.com/webstore/detail/crxmouse-chrome-gestures/jlgkpaicikihijadgifklkbpdajbkhjo';

        return (
            <Background>
                {this.renderOverlays()}
                <PlotAreaWrapper>
                    <StatusBar screen={extensionInstalled ? SCREENS.first : SCREENS.zero} toggleMusicPlaying={toggleMusicPlaying} musicPlaying={musicPlaying}/>
                    <Title>{extensionInstalled ?  I18n.translate('gestureInstructions1') : I18n.translate('openingScreen')}</Title>
                    <PlotArea>
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='3vh' />
                        <PlotAreaMargin margin='5vw'/>
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='9vh' />
                        <PlotAreaMargin margin={extensionInstalled ? '23vw': '10vw'}/>
                        <CenterVerticalColumnWrapper>
                            {!extensionInstalled ? <CenterHorizontalWrapper>
                                <MouseChaseLogo src={`${WP_CONTENT_PREFIX}/images/opening_title.png`}/>
                            </CenterHorizontalWrapper> : null}
                            <CenterHorizontalWrapper>
                                <Mouse src={`${WP_CONTENT_PREFIX}/images/go_back_save_the_princess_mouse.gif`} marginTop={extensionInstalled ? '22vh' : '10vh'}/>
                            </CenterHorizontalWrapper>
                        </CenterVerticalColumnWrapper>
                        <PlotAreaMargin margin='5vw'/>
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='3vh' />
                        <PlotAreaMargin margin='10vw'/>
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='7vh' />
                    </PlotArea>
                </PlotAreaWrapper>
                <GroundInfo extensionInstalled={extensionInstalled} screen={SCREENS.first}>
                    {
                        extensionInstalled ?
                            <React.Fragment>
                                <InfoTitle marginTop="4vh">{I18n.translate('gameReference1')}</InfoTitle>
                                <InfoTitle marginTop="3vh">{ReactHtmlParser(I18n.translate('movementInstructions1'))}</InfoTitle>
                                <GestureGif src={`${WP_CONTENT_PREFIX}/images/down.gif`}></GestureGif>
                            </React.Fragment> :
                            <React.Fragment>
                                <InfoTitle marginTop="4vh">*** {I18n.translate('startGameScreen0')} ***</InfoTitle>
                                <InfoTitle marginTop="1vh">{I18n.translate('firstGestureInstructionDownload')}</InfoTitle>
                                <CTALink onClick={this.ctaClicked} href={extensionPage}>
                                    <CTAWrapper>
                                            <CTASide />
                                            <CTAMiddle>
                                                <CTAImage src={`${WP_CONTENT_PREFIX}/images/chrome.png`} />
                                                {I18n.translate('firstDownloadNow')}
                                            </CTAMiddle>
                                            <CTASide />
                                    </CTAWrapper>
                                </CTALink>
                            </React.Fragment>
                    }
                </GroundInfo>
            </Background>
        );
    }
}
